import { RefObject, useEffect, useRef, useState } from "react";

export const setNativeValue = (element:any, value:any) => {
  const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set;
  const prototype = Object.getPrototypeOf(element);
  const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;

  if (valueSetter && valueSetter !== prototypeValueSetter) {
      prototypeValueSetter?.call(element, value);
  } else {
      valueSetter?.call(element, value);
  }

  element.dispatchEvent(new Event('input', { bubbles: true}));
}

export const pad = (num:number, size:number):string => {
  let res:string = num.toString();
  while (res.length < size) res = "0" + res;
  return res;
}

export const arraysEqualUnordered = (arr1: (number|string)[], arr2: (number|string)[]) => {
  if (arr1.length !== arr2.length) return false;

  const sorted1 = [...arr1].sort();
  const sorted2 = [...arr2].sort();

  return sorted1.every((value, index) => value === sorted2[index]);
}

export function useIsVisibleOnce(options: IntersectionObserverInit  = {}): [RefObject<HTMLElement>, boolean] {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    }, options);

    if (ref.current) observer.observe(ref.current);

    return () => observer.disconnect();
  }, [options]);

  return [ref, visible];
}